import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { Button } from 'reactstrap';
import {
  addScheduleReport,
  getTimeZone,
  getScheduleReportByID,
  updateScheduleReport,
} from '../../../redux/MainAction';
import { toast } from 'react-toastify';

const AddEditScheduleModal = ({ open, onClose, editID }) => {
  const dispatch = useDispatch();
  const zone = useSelector((state) => state?.Webtracker?.timezone);
  const single = useSelector((state) => state?.Webtracker?.scheduleReportByID);

  const [email, setEmail] = useState([{ email: '' }]);

  const [addData, setAddData] = useState({
    reportCode: 'TRACKED_HOURS_CONTRACT',
    mailSubject: '',
    mailMessage: '',
    title: '',
    fileType: 'CSV',
    dateFrequency: 'DAILY',
    reportPeriod: 'TODAY',
    timezoneId: '',
    time: '',
  });

  useEffect(() => {
    getList();
    if (editID) {
      dispatch(getScheduleReportByID({ id: editID }));
    }
  }, [editID]);

  const getList = () => {
    var data = {
      offset: 0,
      limit: 596,
    };
    dispatch(getTimeZone(data));
  };
  const addEmailInvite = () => {
    setEmail([...email, { email: '' }]);
  };

  const removeEmail = (index) => {
    const filterDiet = [...email];
    filterDiet.splice(index, 1);
    setEmail(filterDiet);
  };

  const onChangeAddEmail = (e, index) => {
    const { name, value } = e.target;
    const list = [...email];
    list[index][name] = value;
    setEmail(list);
  };

  const onChangeData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };

  useEffect(() => {
    if (editID) {
      console.log('True', editID);
      setAddData({
        reportCode: single?.reportCode,
        mailSubject: single?.mailSubject,
        mailMessage: single?.mailMessage,
        title: single?.title,
        fileType: single?.fileType,
        dateFrequency: single?.dateFrequency,
        reportPeriod: single?.reportPeriod,
        timezoneId: single?.timezoneId,
        time: single?.time,
      });
      const mails = single?.reportScheduleEmails?.map((mls, idx) => {
        return {
          email: mls?.email,
        };
      });
      console.log('mails', mails);

      setEmail(mails);
    } else {
      setAddData({
        reportCode: 'TRACKED_HOURS_CONTRACT',
        mailSubject: '',
        mailMessage: '',
        title: '',
        fileType: 'CSV',
        dateFrequency: 'DAILY',
        reportPeriod: 'TODAY',
        timezoneId: '',
        time: '',
      });
      setEmail([{ email: '' }]);
    }
  }, [single, editID]);

  console.log('single', single);

  const onSaveHandle = (e) => {
    e.preventDefault();

    const invalidEntries = email?.filter((item) => !item.email);

    const formatEmail = email?.map((itm) => itm?.email);

    if (invalidEntries?.length > 0) {
      // Show error toast for invalid entries
      toast.error('Email is mandatory for all records!');
      return;
    }
    if (addData?.title === '') {
      // Show error toast for invalid entries
      toast.error('title is mandatory!');
      return;
    }
    if (addData?.mailSubject === '') {
      // Show error toast for invalid entries
      toast.error('mail subject is mandatory!');
      return;
    }
    if (addData?.mailMessage === '') {
      // Show error toast for invalid entries
      toast.error('mail message is mandatory!');
      return;
    }

    const payload = {
      reportCode: addData?.reportCode,
      mailSubject: addData?.mailSubject,
      mailMessage: addData?.mailMessage,
      title: addData?.title,
      fileType: addData?.fileType,
      dateFrequency: addData?.dateFrequency,
      reportPeriod: addData?.reportPeriod,
      timezoneId: addData?.timezoneId,
      time: addData?.time,
      emails: formatEmail,
    };
    if (!editID) {
      dispatch(addScheduleReport(payload));
      onClose();
      setAddData({
        reportCode: 'TRACKED_HOURS_CONTRACT',
        mailSubject: '',
        mailMessage: '',
        title: '',
        fileType: 'CSV',
        dateFrequency: 'DAILY',
        reportPeriod: 'TODAY',
        timezoneId: '',
        time: '',
      });
    } else {
      console.log('Updated');
      dispatch(updateScheduleReport({ ...payload, id: editID }));
      onClose();
    }

    console.log('payload', payload);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>{!editID ? 'New' : 'Update'} Schedule Report</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content">
        <div className="row col-12">
          <div className="form-group col-6">
            <label className="text-muted">Report Code</label>
            <div className="">
              <select
                className="form-control"
                name="reportCode"
                value={addData?.reportCode}
                onChange={onChangeData}
              >
                <option>Select Report Code</option>
                <option value="TRACKED_HOURS_CONTRACT">CONTRACT</option>
                <option value="TRACKED_HOURS_PROJECT">PROJECT</option>
                <option value="TRACKED_HOURS_MEMBER">MEMBER</option>
              </select>
            </div>
          </div>
          <div className="form-group col-6">
            <label className="text-muted">Date Frequency</label>
            <div className="">
              <select
                className="form-control"
                name="dateFrequency"
                value={addData?.dateFrequency}
                onChange={onChangeData}
              >
                <option>Select date frequency</option>
                <option value="DAILY">DAILY</option>
                <option value="WEEKLY">WEEKLY</option>
                <option value="MONTHLY">MONTHLY</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label className="text-muted">File Type</label>
            <div className="">
              <select
                className="form-control"
                name="fileType"
                value={addData?.fileType}
                onChange={onChangeData}
              >
                <option>Select Type</option>
                <option value="CSV">CSV</option>
                <option value="XLSX">XLSX</option>
              </select>
            </div>
          </div>
          <div className="form-group col-6">
            <label className="text-muted">Report Period</label>
            <div className="">
              <select
                className="form-control"
                name="reportPeriod"
                value={addData?.reportPeriod}
                onChange={onChangeData}
              >
                <option>Select Report Period</option>
                <option value="TODAY">TODAY</option>
                <option value="YESTERDAY">YESTERDAY</option>
                <option value="7-DAYS">7-DAYS</option>
                <option value="30-DAYS">30-DAYS</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row col-12">
          <div className="form-group col-6">
            <label className="text-muted">Time Zone</label>
            <div className="">
              <select
                className="form-control"
                name="timezoneId"
                value={addData?.timezoneId}
                onChange={onChangeData}
              >
                {zone?.rows?.map((zne, idx) => (
                  <option key={idx} value={zne?.id}>
                    {zne?.display}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-group col-6">
            <label for="username2" className="font-14 text-muted ">
              Time <span className="text-danger">*</span>
            </label>
            <input
              type="time"
              placeholder="Ex. 1"
              className="form-control"
              name="time"
              value={addData?.time}
              onChange={onChangeData}
              id="username2"
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Mail Title <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Mail title"
              className="form-control"
              name="title"
              value={addData?.title}
              onChange={onChangeData}
            />
          </div>
          <div className="form-group col-6">
            <label for="username1" className="font-14 text-muted ">
              Mail Subject <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Mail Subject"
              className="form-control"
              name="mailSubject"
              value={addData?.mailSubject}
              onChange={onChangeData}
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-12">
            <label>
              Mail Message <span className="text-danger">*</span>
            </label>
            <textarea
              type="text"
              className="form-control"
              rows={3}
              name="mailMessage"
              value={addData?.mailMessage}
              placeholder="mail message"
              onChange={onChangeData}
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="d-flex flex-column col-12">
            {email?.map((eml, idx) => (
              <div
                className="d-flex align-items-center"
                style={{ gap: '10px' }}
              >
                <div className="form-group" style={{ width: '90%' }}>
                  <label className="text-muted" for="name">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    id="name"
                    placeholder="Enter email"
                    onChange={(e) => onChangeAddEmail(e, idx)}
                    value={eml?.email}
                  />
                </div>
                <i
                  className="fa fa-trash text-danger mt-2"
                  onClick={() => removeEmail(idx)}
                ></i>
              </div>
            ))}
            <div className="mb-2">
              <Button
                outline
                size="sm"
                color="primary"
                onClick={addEmailInvite}
              >
                Add Email
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <Button size="sm" className="btn btn-light" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" className="btn btn-primary" onClick={onSaveHandle}>
          {' '}
          {!editID ? 'Create' : 'Update'} Schedule Report
        </Button>
      </div>
    </Modal>
  );
};

export default AddEditScheduleModal;
